import React, { useState, useEffect } from 'react';
import { productService } from '../service/productservice';

const RecommendForYou = () => {
  const [randomProducts, setRandomProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchAllProducts = async () => {
      try {
        setLoading(true);
        
        // Define all categories you want to fetch
        const categories = [
          'spongeproducts',
          'beautyproducts',
          'cannedproducts',
          'fruitsproducts',
          'pasteproducts',
          'seafoodsproducts',
          'vegetableproducts',
          'spicesproducts',
          'grainsproducts',
          'floorproducts',
          'oilproducts',
          'ethnicproducts',
          'beveragesproducts',
        ];

        // Fetch products for each category
        const productPromises = categories.map(category => 
          productService.getProductsByCategory(category)
        );

        // Wait for all requests to complete
        const results = await Promise.all(productPromises);
        
        // Combine all products into a single array
        const allProducts = results.flatMap(result => result.products || []);

        // Select random products
        const getRandomProducts = (products, count) => {
          const shuffled = [...products].sort(() => 0.5 - Math.random());
          return shuffled.slice(0, count);
        };

        setRandomProducts(getRandomProducts(allProducts, 5));
       
        setError(null);
      } catch (err) {
        console.error('Error fetching recommended products:', err);
        setError('Failed to load recommendations');
      } finally {
        setLoading(false);
      }
    };

    fetchAllProducts();
  }, []);

  console.log('Recommended Products:', randomProducts);

  if (loading) {
    return (
      <div className="container mx-auto p-4">
        <h2 className="text-2xl font-bold mb-4">Recommended For You</h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
          {[...Array(5)].map((_, index) => (
            <div key={index} className="bg-white shadow-md rounded-lg overflow-hidden animate-pulse">
              <div className="w-full h-48 bg-gray-200"></div>
              <div className="p-4">
                <div className="h-4 bg-gray-200 rounded w-3/4 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
                <div className="h-4 bg-gray-200 rounded w-1/4"></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }

  if (error) {
    return (
      <div className="container mx-auto p-4">
        <h2 className="text-2xl font-bold mb-4">Recommended For You</h2>
        <div className="text-red-500">{error}</div>
      </div>
    );
  }

  return (
    <div className="container mx-auto p-4">
      <h2 className="text-2xl font-bold mb-4">Recommended For You</h2>
      <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-5 gap-4">
        {randomProducts.map((product) => (
          <div key={product._id || product.id} className="bg-white shadow-md rounded-lg overflow-hidden">
            <img 
              src={product.img} 
              alt={product.name} 
              className="w-full h-48 object-cover"
              onError={(e) => {
                e.target.src = 'https://via.placeholder.com/300'; // Fallback image
              }}
            />
            <div className="p-4">
              <h3 className="text-lg font-semibold">{product.name}</h3>
              <p className="text-gray-600">{product.brand}</p>
              <p className="text-green-600 font-bold">${product.price}</p>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default RecommendForYou;